import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionYearPlanQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  isoYear: Types.Scalars['Int']['input'];
}>;


export type GetProductionYearPlanQuery = { __typename?: 'Query', productionYearPlan?: { __typename?: 'ProductionYearPlanStateData', productionYearPlanId: string, siteLocationId: string, isoYear: number, productionPlanId?: string | null, updatedAt: Types.TDateISO, updatedBy: string, items: Array<{ __typename?: 'ProductionYearPlanItemData', productionItemId: string, weeks: Array<{ __typename?: 'ProductionYearPlanWeekData', isoWeek: number, quantity: number }>, plannedLike?: { __typename?: 'ProductionYearPlanLikeData', compProductionItemId: string, percent: number, shiftWeeks: number } | null }> } | null };

export type GetProductionYearPlanYearsQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
}>;


export type GetProductionYearPlanYearsQuery = { __typename?: 'Query', productionYearPlanYears: Array<number> };

export type ProductionYearPlanFieldsFragment = { __typename?: 'ProductionYearPlanStateData', productionYearPlanId: string, siteLocationId: string, isoYear: number, productionPlanId?: string | null, updatedAt: Types.TDateISO, updatedBy: string, items: Array<{ __typename?: 'ProductionYearPlanItemData', productionItemId: string, weeks: Array<{ __typename?: 'ProductionYearPlanWeekData', isoWeek: number, quantity: number }>, plannedLike?: { __typename?: 'ProductionYearPlanLikeData', compProductionItemId: string, percent: number, shiftWeeks: number } | null }> };

export const ProductionYearPlanFieldsFragmentDoc = new TypedDocumentString(`
    fragment ProductionYearPlanFields on ProductionYearPlanStateData {
  productionYearPlanId
  siteLocationId
  isoYear
  productionPlanId
  items {
    productionItemId
    weeks {
      isoWeek
      quantity
    }
    plannedLike {
      compProductionItemId
      percent
      shiftWeeks
    }
  }
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ProductionYearPlanFields"});
export const GetProductionYearPlanDocument = new TypedDocumentString(`
    query GetProductionYearPlan($siteLocationId: String!, $isoYear: Int!) {
  productionYearPlan(siteLocationId: $siteLocationId, isoYear: $isoYear) {
    ...ProductionYearPlanFields
  }
}
    fragment ProductionYearPlanFields on ProductionYearPlanStateData {
  productionYearPlanId
  siteLocationId
  isoYear
  productionPlanId
  items {
    productionItemId
    weeks {
      isoWeek
      quantity
    }
    plannedLike {
      compProductionItemId
      percent
      shiftWeeks
    }
  }
  updatedAt
  updatedBy
}`);
export const GetProductionYearPlanYearsDocument = new TypedDocumentString(`
    query GetProductionYearPlanYears($siteLocationId: String!) {
  productionYearPlanYears(siteLocationId: $siteLocationId)
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionYearPlan: build.query<GetProductionYearPlanQuery, GetProductionYearPlanQueryVariables>({
      query: (variables) => ({ document: GetProductionYearPlanDocument, variables })
    }),
    GetProductionYearPlanYears: build.query<GetProductionYearPlanYearsQuery, GetProductionYearPlanYearsQueryVariables>({
      query: (variables) => ({ document: GetProductionYearPlanYearsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionYearPlanQuery, useLazyGetProductionYearPlanQuery, useGetProductionYearPlanYearsQuery, useLazyGetProductionYearPlanYearsQuery } = injectedRtkApi;
